export const UI_PAGINATOR_PAGE_SIZE_OPTIONS = [10, 20, 50];
